const displayAddress = (addressObj) => {
  const line1 = (addressObj && addressObj && addressObj.line1) || '';
  const line2 = (addressObj && addressObj && addressObj.line2) || '';
  const line3 = (addressObj && addressObj && addressObj.line3) || '';
  const city = (addressObj && addressObj && addressObj.line3) || '';
  const state = (addressObj && addressObj && addressObj.state) || '';
  const address = `${line1 ? `${line1}, ` : ''}${line2 ? `${line2}, ` : ''}${
    line3 ? `${line3}, ` : ''
  }${city ? `${city}, ` : ''}${state || ''}`;
  return address;
};
export default displayAddress;
